import { render, staticRenderFns } from "./lt-menu-actions.vue?vue&type=template&id=225931b0&scoped=true&"
import script from "./lt-menu-actions.vue?vue&type=script&lang=js&"
export * from "./lt-menu-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225931b0",
  null
  
)

export default component.exports